import { verweisteile } from './sprache'

/**
 * Ein Satz, der sagt, was zu tun ist — mit seinem Ziel als Verweis (7.1
 * Abschnitt 13, R1527, R1528).
 *
 * **Der Verweis steht im Satz**, nicht als Knopf daneben: *„Wechseln Sie in
 * den Bereich [Konzernabschlüsse] und rechnen Sie den Konzernabschluss neu."*
 * Das Wort ist das, was der Anwender dort anklickt oder liest. Der Satz kommt
 * mit Marke (`t(…, …, true)`, `satz(…, …, true)`); trägt er keine oder gibt es
 * kein Ziel, steht er als schlichter Text da.
 */
export function Verweissatz({ text, aufVerweis }: { text: string; aufVerweis?: (() => void) | null }) {
  const teile = verweisteile(text)
  if (!teile || !aufVerweis) {
    return <>{teile ? `${teile.vor}${teile.wort}${teile.nach}` : text}</>
  }

  return (
    <>
      {teile.vor}
      <button type="button" className="ortsverweis" onClick={aufVerweis}>
        {teile.wort}
      </button>
      {teile.nach}
    </>
  )
}
